import React from 'react';
import { Box, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';

const AboutSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <Box
        id="about"
        sx={{
          minHeight: '100vh',
          backgroundColor: '#d8d8bc',
          px: 2,
          py: 10,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '240px',
            borderRadius: '10px',
            backgroundImage: 'url(/img/20.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
          }}
        />

        <Box
          sx={{
            width: '100%',
            backgroundColor: '#080808',
            borderRadius: '10px',
            px: 2.5,
            py: 3,
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Oswald',
              fontSize: '42px',
              fontWeight: 700,
              color: '#FFFFFF',
              letterSpacing: '0.04em',
              lineHeight: 0.95,
            }}
          >
            ABOUT
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Oswald',
              fontSize: '42px',
              fontWeight: 700,
              color: '#A8C5E8',
              letterSpacing: '0.04em',
              lineHeight: 0.95,
              mb: 2,
            }}
          >
            US
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: '14px',
              fontWeight: 400,
              color: '#D4C5B0',
              lineHeight: 1.75,
            }}
          >
            Ideated into existence in 2019, Arvira Creations is an Indian, woman-led firm that commits to stand by its promise of delivering high-quality, "primarily" pesticide-free spices to your doorstep!
          </Typography>
        </Box>

        <Typography
          sx={{
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 400,
            color: '#1A1A1A',
            lineHeight: 1.75,
            px: 0.5,
          }}
        >
          We at Arvira, believe in preserving the authenticity of traditionally farmed spices by sourcing them directly from the GAP (Good Agricultural Practice) farmers.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      id="about"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        backgroundColor: '#d8d8bc',
      }}
    >
      {/* <Box sx={{ position: 'absolute', top: { xs: 30, md: 50 }, left: { xs: 30, md: 50 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: { xs: 50, md: 70 },
              height: { xs: 50, md: 70 },
              borderRadius: '50%',
              backgroundColor: '#2858A8',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '3px solid #5B8BC9',
            }}
          >
            <Box
              sx={{
                fontFamily: 'serif',
                fontSize: { xs: '24px', md: '32px' },
                fontWeight: 700,
                color: '#FFFFFF',
              }}
            >
              अ
            </Box>
          </Box>
          <Box>
            <Box
              sx={{
                fontFamily: 'Oswald',
                fontSize: { xs: '16px', md: '20px' },
                fontWeight: 500,
                color: '#1A1A1A',
                lineHeight: 1.2,
              }}
            >
              Arvira
            </Box>
            <Box
              sx={{
                fontFamily: 'Oswald',
                fontSize: { xs: '16px', md: '20px' },
                fontWeight: 500,
                color: '#1A1A1A',
                lineHeight: 1.2,
              }}
            >
              Creations
            </Box>
          </Box>
        </Box>
      </Box> */}
      
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        style={{
          position: 'absolute',
          top: '0%',
          right: '5%',
          width: '50%',
          height: '70%',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundColor: '#080808',
            borderRadius: '4px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            px: { xs: 4, md: 6, lg: 8 },
            py: { xs: 4, md: 6 },
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Oswald',
              fontSize: { xs: '48px', sm: '64px', md: '80px', lg: '96px' },
              fontWeight: 700,
              color: '#FFFFFF',
              letterSpacing: '0.05em',
              lineHeight: 0.9,
              mb: 1,
              marginLeft: '20px',
            }}
          >
            ABOUT
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Oswald',
              fontSize: { xs: '48px', sm: '64px', md: '80px', lg: '96px' },
              fontWeight: 700,
              color: '#A8C5E8',
              letterSpacing: '0.05em',
              lineHeight: 0.9,
              mb: 4,
              marginLeft: '20px',
            }}
          >
            US
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: { xs: '14px', md: '16px', lg: '18px' },
              fontWeight: 400,
              color: '#D4C5B0',
              lineHeight: 1.8,
              marginLeft: '20px',
            }}
          >
            Ideated into existence in 2019, Arvira Creations is an Indian, woman-led firm that commits to stand by its promise of delivering high-quality, "primarily" pesticide-free spices to your doorstep!
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Roboto',
              fontSize: { xs: '14px', md: '16px', lg: '18px' },
              fontWeight: 400,
              color: '#D4C5B0',
              lineHeight: 1.8,
              marginLeft: '20px',
            }}
          >
            We at Arvira, believe in preserving the authenticity of traditionally farmed spices by sourcing them directly from the GAP (Good Agricultural Practice) farmers.
          </Typography>
        </Box>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.4 }}
        style={{
          position: 'absolute',
          bottom: '8%',
          right: '8%',
          width: '40%',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Roboto',
            fontSize: { xs: '14px', md: '16px', lg: '18px' },
            fontWeight: 600,
            color: '#1A1A1A',
            lineHeight: 1.8,
            textAlign: 'left',
            mb: 0.5,
          }}
        >
          We are registered stakeholders with:
        </Typography>
        {[
          'Federation of Indian Export Organisations',
          'Tea Board India',
          'Spices Board of India',
          'Ministry of Commerce And Industry, Government of India'
        ].map((org, i) => (
          <Typography
            key={i}
            sx={{
              fontFamily: 'Roboto',
              fontSize: { xs: '14px', md: '16px', lg: '18px' },
              fontWeight: 400,
              color: '#2858A8',
              lineHeight: 1.7,
              textAlign: 'left',
            }}
          >
            {i + 1}. {org}
          </Typography>
        ))}
        
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{
          position: 'absolute',
          bottom: '0%',
          left: '0%',
          width: '50%',
          height: '70%',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundColor: '#F5F5F5',
            borderRadius: '4px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            backgroundImage: 'url(/img/20.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        />
      </motion.div>
    </Box>
  );
};

export default AboutSection;
